<template>
	<PageContainer>
		<AmeliproCard no-card-header>
			<!--appliquerFiltres est appelée chaque fois que l'évènement filter-changed est émis par le composant RechercheGarde -->
			<RechercheGarde
				ref="rechercheGarde"
				:recherche-dpa="false"
				@filter-changed="appliquerFiltres"
				@afficher-tableau-resultat="handleFilterChange"
			/>
		</AmeliproCard>
		<AmeliproCard no-card-header>
			<ListeGardeByUser
				:filtered-gardes-local="computedFilteredGardes"
				:recherche-garde="true"
				:afficher-detail="true"
				:afficher-tableau-resultat="afficherTableauResultat"
				:titre="titre"
				:statut-filtre="statutFiltre"
				@resultats-disponibles="miseAJourChampsRecherche"
			/>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import { Meta, MetaInfo } from '@/decorators';
	import RechercheGarde from '@/components/garde/RechercheGarde.vue';
	import ListeGardeByUser from '@/components/garde/ListeGardeByUser.vue';
	import RecapitulatifGarde from '@/views/Garde/RecapitulalifGarde.vue';
	import { Garde } from '@/services/api/types';

	@Component({
		components: {
			ListeGardeByUser,
			RechercheGarde,
			RecapitulatifGarde
		}
	})
	export default class GardeComponent extends MixinsDeclaration {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Recherche de gardes' as string
			};
		}

		titre = 'Liste des gardes';
		statutFiltre = '';
		afficherTableauResultat = false;
		filteredGardes: Garde[] = [];

		private isInitialLoad = true;

		get computedFilteredGardes(): Garde[] {
			if (this.isInitialLoad) {
				this.isInitialLoad = false;
				return this.filteredGardes;
			}

			this.afficherTableauResultat = true;
			return this.filteredGardes;
		}

		// Evenement lors d'un changement sur un des champs de recherche
		handleFilterChange(): void {
			this.afficherTableauResultat = false;
		}

		miseAJourChampsRecherche(): void {
			const rechercheGarde = this.$refs.rechercheGarde as
				| RechercheGarde
				| undefined;
			if (rechercheGarde) {
				rechercheGarde.genereFiltres();
			}
		}
	}
</script>
